module.exports = __webpack_public_path__ + "static/media/nodelogo.85458a67.png";